<script setup></script>

<template>
  <div class="flex w-fit space-x-1 bg-white py-1 px-3 border rounded-sm items-center bottom-0 mt-5">
    <p class="text-gray-500 text-xs">{{ $t('emailpref_badge.msg') }}</p>
    <a href="https://www.emailpref.com" target="_blank" class="underline">
      <img class="h-5 w-auto" src="/src/assets/img/logo-light.png" alt="Emailpref" />
    </a>
  </div>
</template>

<style scoped></style>
